{
  "manager": {
    "attendanceAddPersonSidebar": {
      "title": "Create Signup",
      "registrationOpportunity": "Registration Opportunity",
      "personType": "Person Type",
      "findUser": "Find a User",
      "searchPlaceholder": "Search by name or email",
      "submit": "Create Signup",
      "participantExistingMember": "Existing Member",
      "participantWalkIn": "Walk-in",
      "selectPlaceholder": "Select...",
      "selectedUserFallback": "Selected user",
      "createSignupError": "Failed to create signup."
    },
    "attendanceSheetCreateSidebar": {
      "title": "Create Attendance Sheet",
      "program": "Program",
      "registrationOpportunities": "Registration Opportunities",
      "selectOpportunitiesPlaceholder": "Select registration opportunities...",
      "noOpportunitiesAvailable": "No registration opportunities available for this program.",
      "date": "Date",
      "createSheet": "Create Sheet",
      "sheetCreated": "Attendance sheet created",
      "createError": "Failed to create attendance sheet"
    },
    "attendanceSheetIndex": {
      "title": "Attendance Sheets",
      "createSheet": "Create Attendance Sheet",
      "exporting": "Exporting...",
      "exportSelected": "Export Selected",
      "program": "Program",
      "exportStarted": "Attendance sheet export started | Attendance sheets export started",
      "exportError": "Failed to export attendance sheets"
    },
    "attendanceSheetShow": {
      "notFoundTitle": "Attendance Sheet Not Found",
      "notFoundMessage": "The attendance sheet you're looking for doesn't exist or may have been deleted.",
      "attendanceRecords": "Attendance Records",
      "createSignup": "Create Signup",
      "noRecordsYet": "No attendance records yet.",
      "legend": "Legend:",
      "setStatus": "Set Status",
      "addNotesPlaceholder": "Add notes...",
      "saving": "Saving...",
      "saveNote": "Save Note",
      "recordCountSingular": "{count} record",
      "recordCountPlural": "{count} records",
      "pageTitle": "Attendance Sheet - {date}",
      "pageTitleFallback": "Attendance Sheet",
      "notesUpdated": "Notes updated",
      "notesUpdateError": "Failed to update notes",
      "statusUpdated": "Status updated",
      "statusUpdateError": "Failed to update status",
      "bulkStatusUpdated": "{count} record updated to {status} | {count} records updated to {status}",
      "bulkUpdateError": "Failed to update attendance",
      "personAdded": "Person added to attendance"
    },
    "statuses": {
      "present": "Present",
      "absent": "Absent",
      "late": "Late",
      "excused": "Excused",
      "unmarked": "Unmarked"
    }
  }
}
